import React from 'react';
import Head from 'next/head';
// import Scripts from "./Scripts";
import Script from 'next/script';
import { useState, useEffect } from 'react';
import { useRouter } from 'next/router';

const AdHeader = (props: any) => {

  useEffect(() => {
    // console.log('SDK', window?.AdsterSDK);
  }, [props]);

  return (
    <>
      {/* <Head>
        <link
          id='adster-sdk-init-link'
          rel="preload"
          href="https://storage.googleapis.com/public-assets-websdk/cnbcarabia.com.min.js"
          as="script"
        />
        <script
        id='adster-sdk-init'
          dangerouslySetInnerHTML={{
            __html: `
        document.addEventListener('DOMContentLoaded', function() {
          const sdk = new window.AdsterSDK();
          sdk.init();
        }); 
      `,
          }}
        />
        <script id='adster-sdk-init-src' src="https://storage.googleapis.com/public-assets-websdk/cnbcarabia.com.min.js" />
      </Head> */}
    </>
  );
};

export default AdHeader;
